export default {
  Fleet_Phase3_Other_mKWz: '其他',
  Fleet_check_hceA_ycnc: '知道了',
  Fleet_Phase2_Unable_to_ZEyJ: '发送邀请失败，该车辆已被其他司机绑定',
  Fleet_Phase1_Refresh_successfully_sWTn: '刷新成功，今天你的车将会展示给更多司机',
  Fleet_NewPaymentFlow__GUTP: '一次性费用',
  Fleet_NewPaymentFlow__NhvB:
    '从{{begin_datetime}}开始收取。金额：{{Price}}，收取频率：{{Frequency}}',
  Fleet_check_fBNK_CTjZ: '头像审核通过后，你才可以邀请司机。',
  Fleet_Phase3__eugX: '请输入详细地址',
  Fleet_Phase1_My_information_gZpd: '我的资料',
  Fleet_Phase1_Management_laKS: '管理',
  Fleet_Phase2_Unable_to_DjsM: '发送邀请失败，请稍后再试',
  Fleet_Phase2_Not_read_oNht: '未读',
  Fleet_Phase2_Invitation_binding_pNPg: '邀请绑定',
  Fleet_NewPaymentFlow__qyoQ: '{{Expenses_type}}将会自动从你的钱包中扣除。扣除频率：{{Frequency}}',
  Fleet_Phase3__HBGE: '搜索地址',
  Fleet_Phase1__day_TSlN: '{{day_num}}天',
  Fleet_Phase2_Here_is_UUpu: '这是我的简历信息',
  Fleet_Phase1_Please_select_sHdy: '请至少选择一项',
  Fleet_Phase3__YASB: '详细地址',
  Fleet_Phase1_Completed_lnTq: '已填写',
  Fleet_Phase1_Select_from_vFPP: '从相册中选择',
  Fleet_Phase2_Invitation_accepted_jUWV: '已接受邀请',
  Fleet_NewPaymentFlow_TSCH_mgfl: '你需要和司机线下收取租金等其他费用',
  Fleet_6_Approved_iJNK: '审核已通过',
  Fleet_Phase2_Select_a_IWnZ: '请选择一辆车',
  Fleet_Phase3__NQtB: '审核失败',
  Fleet_Phase1_Want_FfcG: '想要',
  Fleet_NewPaymentFlow_svTo_tbpj: '如需要修改，请到个人中心的设置页进行操作',
  Fleet_Phase3_When_it_VfVv:
    '开启后，车头可以看到你的信息并联系你。关闭后，你的信息将不会展示给车头。',
  Fleet_Phase1_Vehicle_Information_GKvX: '车辆资料',
  Fleet_Phase1_Near_wiMy: '附近',
  Fleet_replenish__AsrC: '请输入车头昵称',
  Fleet_Phase2_Unable_to_rFbW: '发送邀请失败，你已经邀请过该司机',
  Fleet_Phase3_Please_fill_TwPJ: '请填写一次性费用类型',
  Fleet_NewPaymentFlow__JGoj: '费用收取方式',
  Fleet_Phase3_Cancel_lhJc: '取消',
  Fleet_Phase2_Sent_successfully_VMHB: '发送成功',
  Fleet_Phase1_Unfilled_information_shzk: '存在未填写的信息',
  Fleet_Phase1_Refresh_vehicle_dBKn: '刷新车辆状态，获得更多的浏览量',
  Fleet_Phase1_Petrol_xPTk: '汽油',
  Fleet_NewPaymentFlow__Wzlo: '设置租金等费用',
  Fleet_MatchingTool_Loading_ingu: '加载中',
  Fleet_Phase1_Select_the_TBEO: '请选择最早可租赁日期',
  Fleet_Phase1_Pick_up_Fzqt: '提车地址',
  Fleet_Phase3_Maintenance_costs_Arun: '维修费',
  Fleet_Phase3_Looking_for_mjCy: '寻找',
  Fleet_Phase2_Go_and_TKGq: '去填写',
  Fleet_NewPaymentFlow_lHPn_FNIg: '请输入你要收取的费用项名称',
  Fleet_Phase3_Fill_in_AwVF: '填写更多你的信息或能提供的服务，让司机更了解你',
  Fleet_Phase3_Handling_address_Kuoh: '提车地址管理',
  Fleet_Phase1_Successfully_removed_Kfwm: '下架成功',
  Fleet_Phase3_To_protect_LYnV:
    '为保护你和车头的隐私，本次通话将使用虚拟号码，请使用{{phone_num}}拨出通话。',
  Fleet_Phase2_Delete_OMUs: '删除',
  Fleet_Phase2_You_have_VdTt: '你已经接受邀请成功，请联系车头完成租车',
  Fleet_Phase1_Successful_collection_cgRX: '收藏成功',
  Fleet_Phase3_Allowing_for_dpCi: '允许推荐给车头',
  GDriver_Name_99_mpNh: '99',
  Fleet_Phase1_Driving_age_CGrZ: '驾龄',
  Fleet_Phase1_Recommended_JWJE: '推荐',
  Fleet_Phase1_Yes_KnFJ: '是',
  Fleet_replenish__Nkhy: '添加失败',
  Fleet_Phase1_There_are_TYqj: '这里有海量优质司机',
  Fleet_Phase2_Waiting_for_CtmY: '等待司机接受邀请',
  Fleet_Phase1_Select_the_arPR: '选择默认图片',
  Fleet_Phase2_Unable_to_mzyp: '接受邀请失败，你已被其他车头绑定',
  Fleet_Phase3__xiYg: '下载{{app_name}}App',
  Fleet_Phase1_Edit_bifa: '编辑',
  Fleet_Phase2_Confirmation_Amgz: '确认',
  Fleet_Phase1_Inactive_vehicles_oKjt: '闲置车辆',
  Fleet_Phase3__RlYg: '该图片不符合要求，请删除后，重新上传车辆真实照片',
  Fleet_Phase1_Vehicle_market_bycj: '寻找车辆',
  Fleet_Phase1_You_modified_ugEp: '你修改了信息，但是没有保存，确认退出吗？',
  Fleet_Phase2_The_message_dvIE: '输入的消息太长，请删减后重试',
  Fleet_Phase1_Types_of_Dcxe: '可提供的服务类型',
  Fleet_Phase3__sjZr: '去开启',
  Fleet_Phase2_Open_message_BjYw: '开启消息通知权限，不错过任何一条消息',
  Fleet_Phase2_Sending_vehicles_VpWK: '发送车辆',
  Fleet_NewPaymentFlow__GCoA: '生效日期',
  Fleet_Phase1_On_the_Zuml: '上架中',
  Fleet_Phase1_Recommended_tZZU: '推荐',
  Fleet_Phase3_Looking_for_VBig: '寻找',
  Fleet_Phase1_Countless_counts_rEma: '暂无数据',
  GDriver_Name_DiDi_Gsik: '滴滴',
  Fleet_Phase1_Open_the_mLYO:
    '请到设置-隐私-定位服务中打开定位服务，并允许{{app_name}}车头使用定位服务',
  Fleet_Phase3_Select_KUZn: '精选',
  Fleet_Phase3_The_driver_lmIm: '司机将通过你的真实号码联系你',
  Fleet_Phase1_Please_enter_kMFd: '请输入联系电话',
  Fleet_Phase2_More_features_rGBL: '这里有更多功能',
  Fleet_deactivation_rxsN_avVX: '该车辆已被下架',
  Fleet_Phase1_Vehicter_vehicles_KaSk: '上架车辆',
  Fleet_Phase1_Fill_in_kRws: '填写你的个人信息，以便车头更快地了解并联系你',
  'kfcommon-fe-i18n---common': {
    inpPlease: '请填写 '
  },
  Fleet_EContract_Email_mdfN: '邮箱',
  Fleet_Phase1_Later_aaAa: '稍后',
  Fleet_Resdesign_Enter_email_cylU: '请输入邮箱',
  Fleet_Phase1_Management_Kglv: '管理',
  Fleet_Phase1_Driver_Market_lUUD: '寻找司机',
  Fleet_Phase3_Add_pickup_rHID: '添加提车地址',
  Fleet_Phase1_The_earliest_BMcv: '最早可租赁时间',
  Fleet_FleetRecommendation_Enter_the_Ykpv: '请输入正确格式的金额',
  Fleet_Phase1_Vehicter_vehicles_cgyn: '上架车辆',
  Fleet_Phase1_Editing_your_VLmr: '编辑简历',
  Fleet_Phase1_Add_a_ZZNX: '添加新车辆',
  Fleet_Phase1_Lower_vehicle_gEAa: '下架车辆',
  Fleet_Phase1_Are_mileage_hsVk: '是否限制里程数？',
  Fleet_Phase1_Add_other_TKWp: '添加其他一次性费用',
  Fleet_NewPaymentFlow__ZQOF: '下一步',
  Fleet_Phase2_Invitation_expired_IedS: '邀请已失效',
  Fleet_Phase1_The_driver_Ktpo: '司机将通过隐私号联系你，你的真实手机号不会展示给司机',
  Fleet_Phase2_You_might_PnzM: '你可能想要',
  Fleet_Phase1_Enter_the_CVAP: '请输入车辆已行驶里程数',
  Fleet_Phase2_Cancel_UgrT: '取消',
  Fleet_NewPaymentFlow__AMrP: '你需要和司机线下收取租金等费用',
  Fleet_Phase2_Your_resume_VFPE: '你的简历还未完善',
  Fleet_Phase1_Do_you_jEQf: '你是否有停车空间？',
  Fleet_Phase1_Open_Location_yZxu: '开启定位权限',
  Fleet_deactivation_ZMOT_xRGi: '以下消息对应的车辆已被下架',
  Fleet_Phase2__Invite_AtyZ: '[邀请你加入车队]',
  Fleet_Phase1_Automatic_file_EBVQ: '自动档',
  Fleet_0303_Fleet_WorkRegime_Withdrawal_oCRI: '司机提现',
  Fleet_Phase1_Waiting_for_hAcD: '等待上架',
  Fleet_Mgt_Pull_down_YzpV: '下拉可以刷新',
  Fleet_Phase1_Cities_with_FYWy: '可提供服务的城市',
  Fleet_NewPaymentFlow__TkSG: '联系车头',
  Fleet_Phase1_Select_vehicle_eTyy: '选择车辆',
  Fleet_Phase1_Weekly_rent_Qcao: '每周租金',
  Fleet_NewPaymentFlow_sKlJ_uHRX: '费用项{{num}}',
  Fleet_Phase2_Accept_the_SSyv: '接受邀请成功',
  Fleet_Phase1_Upload_vehicle_CJxH: '请上传车辆照片',
  Fleet_Phase3_Insurance_UelD: '保险费',
  Fleet_Phase1_Open_positioning_isUK: '开启定位权限可以查看更多信息',
  Fleet_Phase3_Delete_isuY: '删除',
  Fleet_Phase3_Select_city_OuhR: '请选择城市',
  Fleet_Phase1_No_somg: '否',
  Fleet_Phase2__picture_dcAZ: '[图片]',
  Fleet_NewPaymentFlow__aQyj: '添加其它费用',
  Fleet_Phase2_Can_t_Ypzr: '不能发送空白消息',
  Fleet_Phase1_Lease_Information_AcRo: '租赁信息',
  Fleet_Phase2_Fill_in_HjMn: '填写你的简历信息，让车头更方便快捷的了解你',
  Fleet_Phase1_Electric_OCNq: '电动',
  Fleet_check_pajT_vPwq: '请上传头像',
  Fleet_Phase1_Confirmation_hXpq: '确认',
  Fleet_Phase3__ZyyO: '确定退出？',
  Fleet_Phase3__ZGux: '下载{{brand_name}}App',
  Fleet_Phase1_Go_on_lQWv: '去开启',
  Fleet_Phase2_Are_you_tmbn: '确认要接受邀请吗？',
  Fleet_0303_Fleet_WorkRegime_Car_front_XMgw: '车头支付的司机奖励',
  Fleet_Phase2_Upon_acceptance_RppA:
    '接受邀请后，你将会加入该车队，并且绑定该辆车。如果需要解除绑定关系，你需要联系车头。',
  Fleet_Phase1_Display_MPQk: '展示',
  Fleet_Phase2_Send_your_boUl: '发送简历',
  Fleet_NewPaymentFlow__upZL: '费用类型',
  Fleet_Phase3_Agree_GpZc: '同意',
  Fleet_Phase2_Are_you_pyUy: '确认要拉黑对方吗？拉黑后，你将无法接受到对方的消息',
  Fleet_Phase1_Location_hZax: '位置',
  Fleet_Phase1_My_resume_XrBM: '我的简历',
  Fleet_NewPaymentFlow__ZwVw: '费用将会从{{Effective_date}}开始生效',
  Fleet_Phase1_Introduce_more_wgzd: '介绍更多车辆的相关信息，让司机更了解这辆车',
  Fleet_Phase2_Unable_to_BjVG: '接受邀请失败，你已被其他车头邀请',
  Fleet_Phase1_Boleto_FURd: 'Boleto',
  Fleet_NewPaymentFlow_CAbk_WnqE:
    '将会自动从司机的钱包中收取租金等费用，当司机收入不足以支付时，你需要线下找司机收取剩余部分',
  Fleet_Phase3__wuiT: '取消',
  Fleet_Phase3__cGjU: '发送',
  Fleet_Phase2_Latin_America_mcWa: '拉黑',
  Fleet_Phase1_Open_the_qftm:
    '请到设置-隐私-通知服务中打开通知服务，并允许{{app_name}}车头使用通知服务',
  Fleet_Mgt_Loosen_immediately_OZaY: '松开立即刷新',
  Fleet_Phase2_The_invitation_cRjb: '邀请已失效，请联系车头重新发送邀请链接',
  Fleet_MatchingTool_New_NygE: '新的',
  Fleet_Phase2_Message_uxVI: '消息',
  Fleet_Phase1_Mileage_Nbsu: '行驶里程',
  Fleet_Phase1_Select_a_MUGc: '请选择可提供服务的城市',
  Fleet_Phase3__aLzi: '搜索车牌号/车型',
  Fleet_Phase3_Disapproval_WwYC: '不同意',
  Fleet_Phase1_Saved_ukpW: '已收藏',
  Fleet_Phase1_Near_GlZf: '附近',
  Fleet_Phase1_Fill_in_SDNM: '立即填写',
  Fleet_NewPaymentFlow__GiSP: '费用生效时间',
  Fleet_0303_Fleet_WorkRegime_Rental_fares_pUsF: '租车费',
  Fleet_Phase2_Camera_xPcX: '相机',
  Fleet_Phase1_Contact_the_sCYy: '联系司机',
  Fleet_tool_HivM_XeKG:
    '如果你收到来自{{brand_name}}平台之外的信息，请注意核实其可靠性，并警惕虚假信息。',
  Fleet_Phase1__trip_OWdz: '{{trip_num}}单',
  Fleet_Phase3_Set_ozBm: '设置',
  Fleet_Phase1_Vehicles_fail_vWFT: '车辆上架失败，请稍后重试',
  Fleet_Phase1_Credit_card_nkHX: '信用卡',
  Fleet_replenish__YWZk: '车头昵称',
  Fleet_NewPaymentFlow__vurJ:
    '自动收取：租金及其它费用将会自动从你的司机钱包中扣除，不足的部分你需要线下支付给车头',
  Fleet_Phase1_Vehicle_mileage_JJmR: '车辆已行驶里程',
  Fleet_Phase2_I_m_otcY: '我对你的车辆很感兴趣，可以聊聊吗？',
  Fleet_deactivation_vcXF_nzJK: '以下咨询过的车辆已被下架',
  Fleet_NewPaymentFlow__ltIu:
    '将会自动从司机的钱包中收取租金等费用，当司机收入不足以支付时，你需要线下找司机收取剩余部分',
  Fleet_NewPaymentFlow__cGLW:
    '请注意，接受邀请并加入车队后，车头可以直接新增或者修改账单，你无需再次确认。',
  Fleet_Phase3_Contact_number_gTtI: '联系电话',
  Fleet_Drivers_Amount_YOtw: '金额',
  Fleet_Phase3_Urban_upMp: '城市',
  Fleet_NewPaymentFlow__wclB: '请仔细阅读租金等相关费用信息，确认无误后点击接受，即可加入车队',
  Fleet_Phase1_Select_the_DRmS: '请选择变速箱类型',
  Fleet_Phase2_Album_HNuC: '相册',
  Fleet_Phase3_Would_you_XJNH: '是否要删除该提车地址？',
  Fleet_check_IYER_eDig: '头像审核通过后，你才可以给车队下的司机绑定车辆。',
  Fleet_Phase3__wCFx: '已上传',
  Fleet_check_PFze_fown: '头像审核中',
  Fleet_Phase1_Reset_ZyNB: '重置',
  Fleet_NewPaymentFlow__BFLZ: '下一步',
  Fleet_Phase1_Edit_IQWQ: '编辑',
  Fleet_Phase1_Browse_HIWC: '浏览',
  Fleet_Phase1_Payment_Method_fVJF: '支付方式偏好',
  Fleet_Phase1_Click_Change_LCrQ: '点击更换',
  Fleet_Phase3_Cancel_flmb: '取消',
  Fleet_NewPaymentFlow_OSHq_PQkz: '请选择一辆车',
  Fleet_replenish__dJdA: '系统错误，请重试',
  Fleet_Phase1_Next_step_OMuQ: '下一步',
  Fleet_NewPaymentFlow__ydGV: '租赁信息',
  Fleet_Phase1_Star_rating_jYxN: '星级评价',
  Fleet_Phase2_Unable_to_ylbx: '接受邀请失败，该车辆已失效',
  Fleet_Phase2_Confirmation_JNjK: '确认',
  Fleet_Phase1_Payment_Method_wZPV: '支付方式',
  Fleet_check_OZWz_BEqb: '前往上传',
  Fleet_replenish__ZOFV: '呼叫失败，请重试',
  Fleet_Phase3_Other_jpBw: '其它',
  Fleet_Phase1_Unable_to_LSII: '获取通知权限失败',
  Fleet_Phase1_Model_tdll: '车型',
  Fleet_NewPaymentFlow__yzdB: '车辆信息',
  Fleet_Phase3_Unable_to_pVKf: '呼叫失败，请重试',
  Fleet_Phase3_Set_to_rSJK: '设为默认提车地址',
  Fleet_Phase1_Add_your_cKWv: '将你的车辆展示给有租车需求的司机',
  Fleet_Phase3__CXxw: '未开启定位权限',
  Fleet_Phase2_View_Details_MBZa: '查看详情',
  Fleet_Phase1_Type_of_YmjW: '能源类型',
  Fleet_Phase3__gvnI: '无结果',
  Fleet_NewPaymentFlow__QXtF: '每月',
  Fleet_Mgt_No_more_mlms: '没有更多了',
  Fleet_Phase1_Successful_shelves_roWu: '上架成功',
  Fleet_Phase2_Unable_to_UqWk: '发送邀请失败，该司机已被其他车头绑定',
  Fleet_Phase1_Weekly_online_gZHC: '每周在线接单时长',
  Fleet_Phase2_Accept_the_RiKY: '接受邀请',
  Fleet_FleetRecommendation_Contact_number_yTBC: '联系电话',
  Fleet_Phase3_Public_number_KRCc: '公开该号码',
  Fleet_Phase1_Introduce_more_WZRj: '介绍更多自己的相关信息，方便车头了解你',
  Fleet_Phase1_Add_a_QLhS: '添加简历',
  Fleet_Phase1_Refresh_iWvD: '刷新',
  Fleet_Phase1_Enter_the_LXDS: '请输入展示名称',
  Fleet_Phase1_Go_and_ddqt: '去填写',
  Fleet_deactivation_pIlV_dzGd: '车辆即将被下架',
  Fleet_Phase3__XowH: '确认发送邮件？',
  Fleet_Phase3__Gfwg: '上传中',
  Fleet_Phase1_Hand_gear_hAFe: '手动档',
  Fleet_NewPaymentFlow__PRyq: '每天',
  Fleet_Phase1_Enter_the_tbQJ: '请输入金额',
  Fleet_check_Admw_cABo: '暂不同意',
  Fleet_Phase2_Contact_the_xIkV: '联系车头',
  Fleet_Phase2_Action_ZSsi: '选择你想要的操作',
  Fleet_NewPaymentFlow__Khbs: '自动收取',
  Fleet_Phase1_Diesel_rsEa: '柴油',
  Fleet_Phase2_Call_yqck: '打电话',
  Fleet_Phase1_Other_tQVW: '其他',
  Fleet_Phase1_Collection_XqMI: '已收藏',
  Fleet_Phase1_Personal_information_rOpp: '个人信息',
  Fleet_Phase1_Default_image_AFLD: '默认图片',
  Fleet_Phase1_Vehicle_photos_CWvR: '车辆照片',
  Fleet_Phase1_Add_more_ykcL: '添加更多车辆的信息，让你的车更快地租出去',
  Fleet_Drivers_Save_feyd: '保存',
  Fleet_Phase1_Go_vwbQ: '前往',
  Fleet_Phase2_Send_UCas: '发送',
  Fleet_Phase3_Offences_Eyzh: '违章费',
  Fleet_Phase1_Price_JEDD: '价格',
  Fleet_Phase1_Confirmation_and_UFnR: '确认并上架',
  Fleet_Phase1_Add_a_yEOo: '添加车辆照片，让你的车更快地租出去',
  Fleet_Phase2_Waiting_for_PGxV: '等待接受邀请',
  Fleet_Phase1_Select_model_MskT: '请选择车型信息',
  Fleet_Phase3_Pick_up_fDQC: '提车地址',
  Fleet_Phase2_Your_vehicle_etii: '你的车辆{{Vehicle_Plate}}，审核未通过，请尽快完善资料并重新上架',
  Fleet_Phase2_Select_vehicle_DmgM: '选择车辆',
  Fleet_Phase2_Don_t_fbDU: '不想错过最新的消息？',
  Fleet_Phase3__yPol: '为保护你的隐私，该地址将不会对司机完整展示',
  Fleet_Phase3_Show_Name_DTSP: '展示名称',
  Fleet_Phase1_Rental_gIKm: '租金',
  Fleet_Phase1_No_idle_CWLj: '暂无闲置车辆',
  Fleet_Phase2_I_think_iJfP: '我觉得你很适合租我的车，可以聊聊吗？',
  Fleet_Phase1_Cancel_the_jVMw: '取消收藏成功',
  Fleet_Phase1_Week_DoYO: '周',
  Fleet_0303_Fleet_WorkRegime_Driver_Recharge_jdnd: '司机充值',
  Fleet_NewPaymentFlow__bEhi: '租金等费用，将会自动从你的钱包中扣除',
  Fleet_NewPaymentFlow_kWOv_gcBa: '请选择',
  Fleet_deactivation_IDBa_Nsnf: '该车辆已被下架',
  Fleet_v2_Successfully_saved_SuWc: '保存成功',
  Fleet_Phase1_Transmission_box_ntTQ: '变速箱',
  Fleet_Phase1_Select_Energy_jPEr: '请选择能源类型',
  Fleet_Phase1_shelves_gQRG: '上架',
  Fleet_FleetRecommendation_Enter_the_OAao: '请输入正确格式的电话号码',
  Fleet_NewPaymentFlow__EBXA: '线下收取：你需要自行线下向车头支付租金及其它费用',
  Fleet_NewPaymentFlow__xLMz: '租金等费用，你需要线下和车头进行结算',
  Fleet_Phase2_Invitation_to_XuMK: '邀请加入',
  Fleet_Phase1_Delete_vHOi: '删除',
  Fleet_Phase2__CV_ufBg: '[简历]',
  Fleet_Phase1_The_vehicle_iveG: '该车辆已绑定司机，请解绑司机后再次尝试',
  Fleet_Phase3_No_pickup_yaXi: '暂无提车地址',
  Fleet_Phase2_Get_a_ViuM: '获取简历',
  Fleet_Phase1_Star_rating_LMKh: '星级评价',
  Fleet_NewPaymentFlow__TGeN: '租金收取方式',
  Fleet_0303_Fleet_WorkRegime_drawn_front_MIbK: '车头0抽成卡收费',
  Fleet_Phase1_Energy_PPWp: '能源',
  Fleet_Phase1_More_information_QGAV: '更多信息',
  Fleet_Phase2_Unable_to_Mpfg: '发送邀请失败，该司机已被平台封禁',
  Fleet_Phase1_Exit_olZc: '退出',
  Fleet_Phase1_Other_ydLJ: '其他',
  Fleet_Phase2_All_BQZQ: '全部',
  Fleet_Phase1_Please_select_XUaB: '请选择可提供的服务类型',
  Fleet_Phase3_Call_now_MEMz: '立即呼叫',
  Fleet_Phase2_Your_vehicle_Rmil: '你的车辆{{Vehicle_Plate}}上架成功',
  Fleet_Phase1_Home_Page_ezjA: '主页',
  Fleet_check_XKad_fPlI: '请重新上传头像',
  Fleet_Phase2_Are_you_uNIJ: '确认要从列表中删除会话吗？',
  Fleet_0303_Fleet_WorkRegime_Car_wash_XdSy: '洗车费',
  Fleet_Phase1__One_ZBrR: '（一次性费用）',
  Fleet_Phase1_It_s_wzyX: '已经到底了',
  Fleet_Phase3__cYdF: '前往证件审核',
  Fleet_Phase1_The_vehicle_cZTB: '该车辆已经删除，请重新添加',
  Fleet_Phase1_Take_a_SlkQ: '拍照',
  Fleet_report_Division_Information_capz: '司机信息',
  Fleet_NewPaymentFlow__OEob: '{{Expenses_type}}将会直接从你的钱包中一次性扣除',
  Fleet_Phase3_Hidden_Number_tNmI: '隐藏该号码',
  Fleet_Phase1_My_message_SfLZ: '我的信息',
  Fleet_Phase3__jxmA: '邮箱',
  Fleet_NewPaymentFlow__BevI: '每周',
  Fleet_Phase2_I_invite_jgxW: '我邀请你加入我的车队',
  Fleet_Phase1_Mixed_aWEq: '混动',
  Fleet_0303_Fleet_WorkRegime_Other_items_zPbu: '其他项',
  Fleet_0303_Fleet_WorkRegime_Oil_PGEr: '加油费',
  Fleet_Phase2__Fleet_RTrK: '{{Fleet_Name}}邀请你加入车队',
  Fleet_Phase1_Upload_your_NZFc: '请上传车辆证件',
  Fleet_0303_Fleet_WorkRegime_lease_fee_hIok: '手机租赁费',
  Fleet_Phase3__xZGP: '审核结果',
  Fleet_Phase2__Vehicle_mAIO: '[车辆{{Vehicle_Model}}]',
  Fleet_Phase3__lTOd: '未上传证件或证件审核未通过',
  Fleet_Phase1_The_driver_pCZd: '司机将可以通过该邮件直接联系你',
  Fleet_Phase3_User_Services_wNXe: '用户服务协议',
  Fleet_NewPaymentFlow__tgtT: '租金',
  Fleet_Phase3_GNV_amUx: 'GNV',
  Fleet_Phase3_Integrated_sorting_uksd: '综合排序',
  Fleet_Phase3_Deposit_TMrZ: '押金',
  Fleet_NewPaymentFlow_mzMZ_ChLK: '请输入',
  Fleet_Drivers_Go_Settings_vpjg: '去设置',
  Fleet_Phase2_Open_notification_kirV: '打开通知权限，及时获取最新消息',
  Fleet_Phase1_Message_iuXA: '消息',
  Fleet_Phase2_Unable_to_jWPV: '接受邀请失败，请先完成资料审核',
  Fleet_Phase1_Year_uoao: '年',
  Fleet_Phase1_Cancel_JTqC: '取消',
  Fleet_Phase3_Unable_to_nWie: '添加失败',
  Fleet_Phase1_Idle_GiMD: '闲置',
  Fleet_Phase3__LovJ: '退出',
  Fleet_Phase1_Oil_to_UJTc: '油转汽',
  Fleet_Phase1_You_can_zwFo: '你也可以选择上架闲置的车辆',
  Fleet_Phase1_Single_amount_mreo: '单量',
  Fleet_MatchingTool_Confirmation_sFAu: '确认',
  Fleet_check_uiYb_OxPW:
    '由于你的头像未通过审核次数已达到{{reject_max_time}}次，你暂时无法使用该功能，请重新上传正确头像，通过审核后可恢复正常使用。',
  Fleet_Phase3_Cost_type_DhmU: '费用类型',
  Fleet_Phase1_Select_one_YoKe: '请选择一项',
  Fleet_NewPaymentFlow__BVvn: '线下收取',
  Fleet_Phase3_Coming_up_Vjsn: '即将使用加密号码呼出',
  Fleet_MatchingTool_Cancel_Wqtt: '取消',
  Fleet_FMS_Verification_failed_dRqq: '审核失败',
  Fleet_Phase2_Driver_Message_UxZf: '司机消息',
  Fleet_Phase1_Mileage_in_vScJ: '已行驶里程',
  Fleet_NewPaymentFlow__Mhyi: '删除',
  vehicle_info: '车辆信息',
  small: '图片必须小于3MB'
};
